import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'web-design-system-toggle-switch',
  imports: [NgClass],
  templateUrl: './toggle-switch.component.html',
  styleUrl: './toggle-switch.component.scss',
})
export class ToggleSwitchComponent {
  @Input() public label: string;
  @Input() public state: 'default' | 'filled' | 'stroked' | 'default-grey' = 'default';
}
